import React from "react";
import { useTranslation } from "react-i18next";
export default function FormInput({

    label,
    icon,
    type = "text",
    name,
    value,
    onChange,
    placeholder = "",
    error = "",
    helpText = "",
    readOnly = false,
    disabled = false,
    required = false,
    maxLength,
    rows = 4,
    options = [],
    optionValue = "id",
    optionLabel = "label"

}) {

    const { t } = useTranslation();
    //----------------------------------------------------

    const inputClass = `form-control ${
        error ? "is-invalid" : ""
    }`;

    //----------------------------------------------------

    const renderInput = () => {

        switch (type) {

            case "textarea":

                return (

                    <textarea

                        className={inputClass}

                        name={name}

                        rows={rows}

                        value={value || ""}

                        placeholder={placeholder}

                        readOnly={readOnly}

                        disabled={disabled}

                        maxLength={maxLength}

                        onChange={onChange}

                    />

                );

            case "select":

                return (

                    <select

                        className={`form-select ${
                            error ? "is-invalid" : ""
                        }`}

                        name={name}

                        value={value || ""}

                        disabled={disabled}

                        onChange={onChange}

                    >

                        <option value="">

                         
{t("consultant.search.select")}

                        </option>

                        {

                            options.map(item=>(

                                <option

                                    key={item[optionValue]}

                                    value={item[optionValue]}

                                >

                                    {

                                        typeof optionLabel==="function"

                                        ? optionLabel(item)

                                        : item[optionLabel]

                                    }

                                </option>

                            ))

                        }

                    </select>

                );

            default:

                return (

                    <input

                        type={type}

                        className={inputClass}

                        name={name}

                        value={value || ""}

                        placeholder={placeholder}

                        readOnly={readOnly}

                        disabled={disabled}

                        maxLength={maxLength}

                        onChange={onChange}

                    />

                );

        }

    };

    //----------------------------------------------------

    return (
        <div className="form-input mb-4">
            {
                label &&
                <label className="form-label fw-semibold">
                    {
                        icon &&
                        <i
                            className={`bi ${icon} me-2 text-primary`}
                        ></i>
                    }
                    {label}
                    {
                        required &&
                        <span className="text-danger ms-1">
                            *
                        </span>
                    }
                </label>
            }
            {renderInput()}
            {
                helpText &&
                <div className="form-text">
                    {helpText}
                </div>
            }
            {
                maxLength &&
                <div className="text-end text-muted small">
                    {(value || "").length}
                    /
                    {maxLength}
                </div>
            }
            {
                error &&
                <div className="invalid-feedback d-block">
                    {error}
                </div>
            }
        </div>
    );
}